const selectedPropertyAction = (property) => {
  return {
    type: 'UPDATE_SELECTED_PROPERTY',
    payload: property,
  }
}

export default selectedPropertyAction
